import api from 'services/api';
import { UserDataResponse } from '.';

export const apiToApp = ({
  largeProfileImageUrl,
  ...rest
}: UserDataResponse) => ({
  ...rest,
  avatar: largeProfileImageUrl,
});

export const loadUserData = async () => {
  return api.get<UserDataResponse>('user/').then(({ data }) => apiToApp(data));
};
